export const objectToQueryString = (obj: any): string => {
  const parts = [];

  for (const key in obj) {
    if (
      obj.hasOwnProperty(key) &&
      obj[key] !== null &&
      obj[key] !== undefined
    ) {
      const value = Array.isArray(obj[key]) ? obj[key].join(",") : obj[key];

      parts.push(encodeURIComponent(key) + "=" + encodeURIComponent(value));
    }
  }

  return parts.join("&");
};

export const objectToQueryStringWithArray = (obj: any): string => {
  const params = new URLSearchParams();

  for (const key in obj) {
    if (
      obj.hasOwnProperty(key) &&
      obj[key] !== null &&
      obj[key] !== undefined
    ) {
      if (Array.isArray(obj[key])) {
        for (const val of obj[key]) {
          // Agrega múltiples valores
          params.append(key, val);
        }
      } else {
        params.append(key, obj[key]);
      }
    }
  }

  return params.toString();
};

export const normalize = (str: string) => str.trim().toLowerCase();

export const isEmpty = (val: any) =>
  !val || (Array.isArray(val) ? val?.length === 0 : val === "");

export const formatCurrencyInputToNumber = (el: string | number): number => {
  if (typeof el === "number") return el;
  if (!el || typeof el !== "string") return 0;

  const clean = el.replaceAll(/[^\d.,-]/g, "");

  const lastDot = clean.lastIndexOf(".");
  const lastComma = clean.lastIndexOf(",");

  let normalized: string;

  if (lastComma > lastDot) {
    // caso "12.345,67" → coma como decimal
    normalized = clean.replaceAll(".", "").replace(",", ".");
  } else if (lastDot > lastComma) {
    // caso "12,345.67" o "12345.67" → punto como decimal
    normalized = clean.replaceAll(",", "");
  } else {
    // sin separadores → usar tal cual
    normalized = clean;
  }

  const num = Number(normalized);
  return Number.isNaN(num) ? 0 : Number(num.toFixed(2));
};

export const parseTonInputToNumber = (value: string | number | undefined | null): number | undefined => {
  if (value === undefined || value === null || value === ("" as any)) return undefined;

  let tonStr = String(value);

  // Normalizar puntos a comas
  tonStr = tonStr.replaceAll(".", ",");
  // Mantener solo dígitos y coma
  tonStr = tonStr.replaceAll(/[^0-9,]/g, "");

  const parts = tonStr.split(",");
  if (parts.length > 1) {
    const intPart = parts[0];
    const decPart = parts.slice(1).join("").slice(0, 3);
    tonStr = decPart.length > 0 ? `${intPart},${decPart}` : `${intPart},`;
  } else {
    tonStr = parts[0];
  }

  if (tonStr.startsWith(",")) {
    tonStr = `0${tonStr}`;
  }

  const parsedTon = Number.parseFloat(tonStr.replace(",", "."));
  return Number.isNaN(parsedTon) ? undefined : parsedTon;
};

// maxIntegerDigits acota la parte entera (p. ej. 7 para un decimal(10,3) de
// DB, que admite 7 dígitos enteros + 3 decimales). Sin ese límite el tope de
// 3 decimales no alcanza para evitar un overflow de precisión en el backend.
export const handleTonChangeInInput = (
  e: React.ChangeEvent<HTMLInputElement>,
  maxIntegerDigits?: number,
) => {
  let val = e.target.value || "";
  // Normalize dots to commas
  val = val.replaceAll(".", ",");
  // Keep only digits and comma
  val = val.replaceAll(/[^0-9,]/g, "");
  // Ensure single comma and max 3 decimals
  const parts = val.split(",");
  const hasComma = parts.length > 1;
  let intPart = parts[0];
  const decPart = hasComma ? parts.slice(1).join("").slice(0, 3) : undefined;

  if (maxIntegerDigits && intPart.length > maxIntegerDigits) {
    intPart = intPart.slice(0, maxIntegerDigits);
  }

  if (decPart !== undefined) {
    val = decPart.length > 0 ? `${intPart},${decPart}` : `${intPart},`;
  } else {
    val = intPart;
  }
  // Prevent leading comma (",123") -> "0,123"
  if (val.startsWith(",")) {
    val = `0${val}`;
  }
  e.target.value = val;
};
